/**
 * Invitation Code Service
 * Handles all invitation code related API calls
 */

import { apiClient } from './apiClient';

export type InvitationCodeOwner = {
  owner_name: string;
  owner_email: string;
  owner_phone: string | null;
  owner_image: string | null;
};

type GetPublicOwnersResponse = {
  owners: InvitationCodeOwner[];
};

export const invitationCodeService = {
  async getPublicOwners() {
    return apiClient<GetPublicOwnersResponse>('/api/invitation-codes/owners', {
      skipRefreshOnUnauthorized: true,
    });
  },
};
